import { render, staticRenderFns } from "./ttshop_usermyorder.vue?vue&type=template&id=0d3bd8aa&scoped=true&"
import script from "./ttshop_usermyorder.vue?vue&type=script&lang=js&"
export * from "./ttshop_usermyorder.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_usermyorder.vue?vue&type=style&index=0&id=0d3bd8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3bd8aa",
  null
  
)

export default component.exports